<template>
  <div>
    <div class="row">
      <div>
        <staffsal :data="sta_sal" :title="title[1]" />
      </div>
      <div>
        <prestaff :data="sta_fun" :cur_cod="cur_cod" :title="title[2]" />
      </div>
    </div>
    <div class="row">
      <div>
        <preempcont :data="sta_eect" :title="title[3]" />
      </div>
      <div>
        <staffedu :data="sta_tra" :title="title[4]" />
      </div>
    </div>
  </div>
</template>

<script>
import staffSalary from "@/components/ascf/sharedCom/staffSalaryPre.vue";
import staffEducation from "@/components/ascf/sharedCom/staffEducation.vue";
import preEmpContract from "@/components/ascf/pre/preEmpContract.vue";
import preStaffExtra from "@/components/ascf/pre/preStaffExtra.vue";

export default {
  props: ["title", "sta_sal", "sta_fun", "sta_eect", "sta_tra", "cur_cod"],
  components: {
    prestaff: preStaffExtra,
    staffsal: staffSalary,
    staffedu: staffEducation,
    preempcont: preEmpContract
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.row {
  display: flex;
}
</style>